import styled, { css } from "styled-components"
import bg from "images/listing-overlay.png"

const CarouselItemBg = styled.div`
    /* background-image: ${props => props.theme.colors.gradient}; */
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity .4s ease;
    z-index: 1;

    ${props => props.video && css`
        opacity: 0.6;
        border: 0;

        &:hover {
            ${props => (props.borderOnHover === "yes") && css`
                border: 5px solid ${props => props.theme.colors.secondary};
            `}
        }
    `}

    &:after {
        content: "";
        background-image: url("${bg}");
        background-size: cover;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        ${props => (props.borderOnHover === "yes") && css`
            border: 5px solid ${props => props.theme.colors.secondary};
        `}

        ${props => props.video && css`
            background-image: none;
            background-color: black;
            opacity: 1;
            border: 0;

            &:hover {
                ${props => (props.borderOnHover === "yes") && css`
                    border: 5px solid ${props => props.theme.colors.secondary};
                `}
            }
        `}
    }

    div {
        position: absolute;
        display: block;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        color: white;
        border: 4px solid ${props => props.theme.colors.secondary};
        line-height: 1;
        padding: .5rem 1rem;
        white-space: nowrap;
        text-transform: uppercase;
        font-size: ${props => props.theme.font.size.sm};
        font-family: ${props => props.theme.font.family.base};

        /* || props.type === "NewsListing" */
        ${props => (props.type === "ColumnedImageWithText" || props.type === "gallery") && css`
            top: 50%;
        `}
    }
`

export default CarouselItemBg